import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalculator = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M7.943 0h16.114c1.795 0 3.132 1.337 3.132 3.131V28.87c0 1.795-1.337 3.131-3.132 3.131H7.943c-1.795 0-3.132-1.337-3.132-3.131V3.13C4.811 1.337 6.148 0 7.943 0zm16.114 9.623V3.13H7.943v6.492zM11.19 16v-3.246H7.943V16zm6.377 0v-3.246h-3.132V16zm6.491 0v-3.246h-3.246V16zM11.19 22.377v-3.131H7.943v3.131zm6.377 0v-3.131h-3.132v3.131zm6.491 0v-3.131h-3.246v3.131zM11.19 28.87v-3.246H7.943v3.246zm6.377 0v-3.246h-3.132v3.246zm6.491 0v-3.246h-3.246v3.246z" /></svg>;
export default SvgCalculator;